import { useEffect, useState } from "react";

/** A text edit is one saved command. Unsaved text keeps native text undo. */
export function AnnotationTextInput({value, onCommit, onFocus, ...props}: {
  value: string; onCommit: (value: string) => Promise<void>; onFocus?: () => void;
  "aria-label"?: string; placeholder?: string; list?: string;
}) {
  const [draft, setDraft] = useState(value);
  const [error, setError] = useState("");
  useEffect(() => { setDraft(value); }, [value]);
  return <input {...props} value={draft} data-annotation-input="true" data-dirty={draft !== value}
    aria-invalid={!!error} title={error || "Enter or leave the field to save"}
    onFocus={onFocus} onChange={e => {setDraft(e.target.value);setError("");}}
    onKeyDown={e => {
      if (e.key === "Enter") {e.preventDefault();e.currentTarget.blur();}
      if (e.key === "Escape") {e.preventDefault();e.stopPropagation();setDraft(value);}
    }}
    onBlur={() => {if (draft !== value) void onCommit(draft.trim()).catch(e => {setError(e.message);setDraft(value);});}} />;
}
